<template>
  <section class="worth">
    <div class="container">
      <a-typography-title :level="1">
        桌面级生成式AI应用平台
      </a-typography-title>
      <a-typography-paragraph>
        提供丰富的热门AI应用和适配国内主流AI大模型，实现即插即用的便捷体验
      </a-typography-paragraph>
      <div class="box_list">
        <div v-for="(item,index) in expand.list" ref="item"
             class="item" :class="[`i_${index+1}`,index+1===expand.active?'active':'']">
          <a-typography-title :level="5">
            {{ item.title }}
          </a-typography-title>
          <a-typography-paragraph>
            <!--<p v-for="v in item.text">-->
            <!--  {{ v }}-->
            <!--</p>-->
            {{ item.text }}
          </a-typography-paragraph>
        </div>
      </div>
      <a-space :size="$Store.Public().isGridMatch('>=',$Enum.GridEnum.XL)?'large':'small'">
        <a-button type="link" class="button_n_3"
                  @click="clickToWhiteBook()">
          免费部署
        </a-button>
        <!--<a-button type="link" class="button_n_3"-->
        <!--          @click="$Store.Page().openModal('modalFormCollection', 'demo')">-->
        <!--  预约咨询-->
        <!--</a-button>-->
      </a-space>
    </div>
  </section>
</template>

<script lang="ts" type="text/tsx">
import { DataInterface } from '@interface/public';

export default {
  name: 'plan_worth',
  data(): DataInterface {
    return {
      expand: {
        active: 1,
        list: [
          {
            title: '精选AI应用',
            text: 'AI应用平台持续更新，涵盖热门AI工具，如知识库、智能客服、BI数据分析、图标设计、PDF内容摘要等多场景应用。支持即装即用，助力团队迅速提升AI办公效率。'
          },
          {
            title: '多模型支持',
            text: '通过单一账号，您可以接入多家大型模型供应商的各类模型版本，如文本模型、多模态模型、Embedding模型等。您可以根据实际效果挑选最合适的模型，以实现最佳效果。'
          },
          {
            title: '多环境支持',
            text: '支持个人电脑安装，兼容信创电脑及服务器安装。支持WindowOS、MacOS、Linux平台。'
          }
        ]
      }
    };
  },
  mounted(): void {
    this.listenMouseOver();
  },
  methods: {
    /**
     * 监听鼠标移动
     */
    listenMouseOver(): void {
      this.$refs.item.forEach((v: HTMLElement, i: number) => {
        v.addEventListener('mouseover', () => {
          this.expand.active = i + 1;
        }, false)
      });
    },
    
    /**
     * 点击去白皮书
     */
    clickToWhiteBook(): void {
      // location.href = 'https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd';
      open('https://galaxy-future.feishu.cn/docx/BpfYdxcOYoNbXYxEHk8ce0OHnLd');
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import '@resource/css/_global.less';


@image: '@{src_image}page/productSchedulX/';
@border: 1px solid @color_14;

.worth {
  overflow: hidden;
  position: relative;
  padding: 0 @padding;
  background: @color_white;
  
  .container {
    position: relative;
    max-width: @grid_xl;
    padding: @space 0;
    margin: 0 auto;
    .borderBox();
    text-align: center;
  }
}

h1.ant-typography {
  margin: 0;
  .font(center, @title, @color_12, @title, true);
}

div.ant-typography {
  margin: @margin_mo 0 0;
  .font(center, @text+@line, @color_13, @text);
}

.box_list {
  overflow: hidden;
  position: relative;
  margin: @margin_mo 0 0;
  border: @border;
  .borderBox();
  .shadow(0 0 20px fade(@color_black, 5));
}

.item {
  @style: width @time, background @time;
  float: left;
  overflow: hidden;
  position: relative;
  width: 20%;
  height: 360px;
  .bg('@{image}worth_item_bg.jpg');
  background-size: cover;
  //.transition(@style);
  
  .loop(@i) when (@i<=5) {
    &.i_@{i} {
      border-left: if(@i>1, @border, none);
      border-right: if(@i<5, @border, none);
      
      h5.ant-typography::before {
        .bg('@{image}worth_icon_@{i}.png', 160px, 150px, true);
      }
    }
    .loop(@i+1);
  }
  .loop(1);
  
  &.active {
    width: 60%;
    background: @color_white;
    
    h5.ant-typography {
      .transform(translate(-50%, calc(~'-50% - 65px')));
    }
    
    div.ant-typography {
      opacity: 1;
      .transform(translate(-50%, -65px));
    }
  }
  
  h5.ant-typography {
    .center();
    z-index: 1;
    .font(center, @text_big+4px, @color_12, @text_big+4px, true);
    .transition(transform @time);
    
    &::before {
      content: '';
      display: block;
      margin: 0 auto @margin_mo;
    }
  }
  
  div.ant-typography {
    @h: 130px;
    @style: opacity @time, transform @time;
    .position(absolute, auto, auto, -65px, 50%);
    z-index: 1;
    max-width: 500px;
    width: 100%;
    height: @h;
    padding: 0 @padding;
    margin: 0 auto;
    .font(justify, @text+@line, @color_13, @text);
    opacity: 0;
    .transform(translate(-50%, 0));
    .transition(@style);
    
    p {
      position: relative;
      padding-left: 15px;
      margin: 0;
      
      &::before {
        content: '';
        display: block;
        .position(absolute, 10px, auto, auto, 0);
        width: 4px;
        height: 4px;
        background: @color_6;
        border-radius: 50%;
      }
    }
  }
}

.ant-space {
  margin: @margin 0 0;
}

@media screen and (max-width: -1px+@grid_lg) {
  .box_list {
    overflow: initial;
    border: none;
    .shadow(none);
  }
  
  .item {
    float: none;
    width: 100% !important;
    max-width: 360px;
    height: auto;
    padding: 160px 0 20px;
    margin: 20px auto 0;
    background: @color_white;
    border: @border !important;
    .shadow(0 0 20px fade(@color_black, 5));
    
    &:nth-child(1) {
      margin-top: 0;
    }
    
    .loop(@i) when (@i<=5) {
      &.i_@{i} {
        @style: 0.6px;
        
        h5.ant-typography::before {
          .bg('@{image}worth_icon_@{i}.png', 160px*@style, 150px*@style, true);
        }
      }
      .loop(@i+1);
    }
    .loop(1);
    
    h5.ant-typography {
      .position(top, 20px);
      .transform(translate(0, 0)) !important;
    }
    
    div.ant-typography {
      position: relative;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      height: auto;
      opacity: 1 !important;
      .transform(translate(0, 0)) !important;
    }
  }
}

@media screen and (max-width: -1px+@grid_md) {
  .worth {
    .container {
      padding: @space_mo 0;
    }
  }
  
  h1.ant-typography {
    .font(center, @title_mo+@line_mo, @color_12, @title_mo, true);
  }
  
  div.ant-typography {
    .font(center, @text_big_mo+@line_mo, @color_12, @text_big_mo);
  }
  
  .item {
    h5.ant-typography {
      .font(center, @text_big_mo, @color_12, @text_big_mo, true);
    }
    
    div.ant-typography {
      .font(justify, @text_mo+@line_mo, @color_13, @text_mo);
    }
  }
  
  .ant-space {
    margin: @margin_mo 0 0;
  }
}
</style>